// extracted by mini-css-extract-plugin
export default {"fieldContainer":"w2gpbIJCiy25vMavmYVw","linkIcon":"HbrFTA77UXI_3SlIsGHK","idlink":"oloHVjyXf2DrxIcpmw6I"};